import {
  EnqueteTemplateAdapterInteface,
  ListEnqueteTemplatesInput,
} from 'src/adapter/EnqueteTemplateAdapterInterface';
import {
  EnqueteTemplateSendAttributes,
  EnqueteTemplateGetAttributes,
} from 'src/models/EnqueteTemplateModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosEnqueteTemplateAdapter
  implements EnqueteTemplateAdapterInteface
{
  async listEnqueteTemplates(
    conditions?: ListEnqueteTemplatesInput
  ): Promise<{ total: number; data: EnqueteTemplateGetAttributes[] }> {
    try {
      const res = await api.get('/enquete-templates', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getEnqueteTemplate(id: string): Promise<EnqueteTemplateGetAttributes> {
    try {
      const res = await api.get(`/enquete-templates/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createEnqueteTemplate(
    attributes: EnqueteTemplateSendAttributes
  ): Promise<EnqueteTemplateGetAttributes> {
    try {
      const res = await api.post('/enquete-templates', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateEnqueteTemplate(
    id: string,
    attributes: EnqueteTemplateSendAttributes
  ): Promise<EnqueteTemplateGetAttributes> {
    try {
      const res = await api.put(`/enquete-templates/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteEnqueteTemplate(id: string): Promise<boolean> {
    try {
      return await api.delete(`/enquete-templates/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
